module.exports = __webpack_public_path__ + "img/009.fd87db89.jpg";